"use client";

import { useState, useRef } from "react";
import Image from "next/image";
import Link from "next/link";

// Organize testimonials in the specific column arrangement from the image
const testimonials = [
  // Column 1: Abhishika + Nishank Video
  {
    column: 1,
    items: [
      {
        id: 1,
        content: "Excited to announce my graduation 🎓from the UX Career Acceleration Program by GrowthSchool under the mentorship of Anudeep Ayyagari (UX Anudeep) . It's been an enriching journey exploring UX concepts, design tools🛠️, and the realm of product design. Collaborating with talented peers, we've delved into crafting ...",
        author: "Abhishika K.N",
        role: "Engineer - 2 - Version",
        image: "https://d3kl8zsmmx4oop.cloudfront.net/K_N_Abhishika_02d404b42b.jpeg"
      },
      {
        id: 2,
        isVideo: true,
        videoUrl: "https://d31bwppm8yl9g2.cloudfront.net/learner/website/gstest1.mp4",
        videoAuthor: "Nishank Koushak",
        videoRole: "Senior Sales Manager, SingleInterface"
      }
    ]
  },
  // Column 2: Rahul + Nidhi
  {
    column: 2,
    items: [
      {
        id: 3,
        content: "✨ Just completed Vaibhav Sisinty's LinkedIn workshop at GrowthSchool – mind officially blown! 🌀 Ready to share the top three secrets that turned my LinkedIn game around. 💪🏽🚀 Crafting a magnetic headline, mastering connection requests, and decoding the LinkedIn algorithm – all in one session! 🚀📈 Let'...",
        author: "Rahul Phathani",
        role: "Social Media Strategist, LinkedIn",
        image: "https://d3kl8zsmmx4oop.cloudfront.net/Rahul_Pahlani_00cac714b3.jpeg"
      },
      {
        id: 4,
        content: "I am thrilled to share that I have developed a dynamic and insightful dashboard on Power BI, providing real-time predictions and analysis of the USD-INR exchange rates. With this dashboard, you can track the latest trends, historical data, and forecasted movements of the USD-INR exchange rates. It's an invaluab...",
        author: "Nidhi worah",
        role: "Computer Vision Engineer, Ignitus",
        image: "https://d3kl8zsmmx4oop.cloudfront.net/Nidhi_713c10d201.jpg"
      }
    ]
  },
  // Column 3: Akash + Tushar Video + Nivedan
  {
    column: 3,
    items: [
      {
        id: 5,
        content: "I landed my first international client with Growth School's LinkedIn Workshop. Here are the things I discovered over the five-day workshop: 1. Having an optimised profile makes you more credible and approachable. 2. You can do wonders with the Featured Section - if done the right way. 3. Followers don't matter ...",
        author: "Akash Pandey",
        role: "Instagram Growth Coach, Instagram",
        image: "https://d3kl8zsmmx4oop.cloudfront.net/Akash_Pandey_58a27d6451.jpeg"
      },
      {
        id: 6,
        isVideo: true,
        videoUrl: "https://d31bwppm8yl9g2.cloudfront.net/learner/website/gstest2.mp4",
        videoAuthor: "Tushar Baweja",
        videoRole: "Investigation Specialist 1, Amazon"
      }
    ]
  },
  // Column 4: Sumit + Kaushik + Manish
  {
    column: 4,
    items: [
      {
        id: 8,
        content: "Hey Folks Excited to start this new year with a bang with the Digital Marketing Program with GrowthSchool. All set to begin the journey with the Learners on 7th Jan! The best part - I'll be driving the program alongside some of the top industry veterans including but NOT Limited to: Kaushik Sen Deka (Digital Ma...",
        author: "sumit varma",
        role: "Media Account Specialist Head, Google",
        image: "https://d3kl8zsmmx4oop.cloudfront.net/Sumit_Tyagi_f30773827d.jpg"
      },
      {
        id: 9,
        content: "Hey Folks! HNY 2024!🎉 Excited to start this new year with a bang with the Digital Marketing Program with GrowthSchool. All set to begin the journey with the Learners on 7th Jan! The best part - I'll be driving the program alongside some of the top industry veterans including but NOT Limited to: Sumit Verma (M...",
        author: "Kaushik Sen",
        role: "Digital Marketing Strategist, Google",
        image: "https://d3kl8zsmmx4oop.cloudfront.net/Kaushik_Sen_Deka_675892f34d.jpeg"
      }
    ]
  }
];

export default function TestimonialsSection() {
  // State to track which videos are playing
  const [playingVideos, setPlayingVideos] = useState({});
  // Refs to store video elements
  const videoRefs = useRef({});

  // Function to handle video play/pause
  const toggleVideo = (videoId) => {
    const videoElement = videoRefs.current[videoId];
    
    if (!videoElement) return;

    const isCurrentlyPlaying = playingVideos[videoId];
    
    if (isCurrentlyPlaying) {
      // Pause the video and reset to beginning
      videoElement.pause();
      videoElement.currentTime = 0;
    } else {
      // Play the video
      videoElement.play().catch(e => console.error("Video play error:", e));
    }

    setPlayingVideos(prev => ({
      ...prev,
      [videoId]: !isCurrentlyPlaying
    }));
  };

  return (
    <section className="py-8 md:py-16 px-4 md:px-0 w-full md:w-[80%] mx-auto overflow-hidden">
      <div className="mb-6 md:mb-8">
        <p className="text-[#002726] text-base md:text-xl font-medium uppercase mb-2">HEAR IT FROM THEM</p>
        <h2 className="text-[#002726] text-2xl md:text-3xl lg:text-4xl font-medium flex flex-wrap items-center gap-2">
          Ambitious People <span className="text-2xl md:text-3xl">❤️</span> GrowthSchool
        </h2>
      </div>

      {/* Mobile: Single column layout */}
      <div className="block md:hidden">
        <div className="flex flex-col gap-4">
          {testimonials.flatMap(column => column.items).map((testimonial) => (
            <div 
              key={testimonial.id} 
              className="w-full border border-gray-200 rounded-xl overflow-hidden relative bg-white"
            >
              {testimonial.isVideo ? (
                // Video Card
                <div className="relative aspect-[16/9] md:aspect-[4/3]">
                  {/* The video element */}
                  <video 
                    ref={(el) => {
                      if (el) videoRefs.current[testimonial.id] = el;
                    }}
                    src={testimonial.videoUrl}
                    className="w-full h-full object-cover"
                    controls={playingVideos[testimonial.id]}
                    playsInline
                    muted={!playingVideos[testimonial.id]}
                    onEnded={() => {
                      setPlayingVideos(prev => ({
                        ...prev,
                        [testimonial.id]: false
                      }));
                    }}
                  />
                  
                  {/* Play Button - only shown when video is not playing */}
                  {!playingVideos[testimonial.id] && (
                    <div 
                      className="absolute inset-0 flex items-center justify-center cursor-pointer z-20"
                      onClick={() => toggleVideo(testimonial.id)}
                    >
                      <div className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-white/30 flex items-center justify-center">
                        <div className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-white flex items-center justify-center">
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M5 3L19 12L5 21V3Z" fill="#012726"/>
                          </svg>
                        </div>
                      </div>
                    </div>
                  )}
                  
                  {/* Author details - only shown when video is not playing */}
                  {!playingVideos[testimonial.id] && (
                    <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/60 to-transparent p-3 md:p-4 z-10">
                      <h3 className="text-white font-bold text-sm md:text-base">{testimonial.videoAuthor}</h3>
                      <p className="text-white text-xs md:text-sm opacity-90">{testimonial.videoRole}</p>
                    </div>
                  )}
                </div>
              ) : (
                // Text Card
                <div className="p-4 md:p-5 flex flex-col h-auto">
                  {/* LinkedIn Icon */}
                  <div className="absolute top-2 right-2">
                    <Image 
                      src="https://d31bwppm8yl9g2.cloudfront.net/learner/website/gslink.svg"
                      alt="LinkedIn"
                      width={28}
                      height={28}
                      className="object-contain"
                    />
                  </div>
                  {/* Testimonial content */}
                  <p className="text-[#012726] text-sm font-normal mb-4 mt-6 leading-relaxed">{testimonial.content}</p>
                  
                  {/* Author details */}
                  <div className="flex items-center gap-3 mt-auto">
                    <div className="relative w-10 h-10 md:w-12 md:h-12 rounded-sm overflow-hidden flex-shrink-0">
                      <Image 
                        src={testimonial.image}
                        alt={testimonial.author}
                        fill
                        className="object-cover"
                      />
                    </div>
                    <div className="min-w-0 flex-1">
                      <h3 className="text-[#012726] text-sm md:text-base font-medium truncate">{testimonial.author}</h3>
                      <p className="text-gray-600 text-xs md:text-sm text-normal">{testimonial.role}</p>
                    </div>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>

      {/* Desktop: Multi-column layout */}
      <div className="hidden md:grid md:grid-cols-2 lg:grid-cols-4 gap-5">
        {testimonials.map((column) => (
          <div key={`column-${column.column}`} className="flex flex-col gap-5">
            {column.items.map((testimonial) => (
              <div 
                key={testimonial.id} 
                className="w-full border border-gray-200 rounded-xl overflow-hidden relative bg-white"
              >
                {testimonial.isVideo ? (
                  // Video Card
                  <div className="relative aspect-[4/3]">
                    {/* The video element */}
                    <video 
                      ref={(el) => {
                        if (el) videoRefs.current[testimonial.id] = el;
                      }}
                      src={testimonial.videoUrl}
                      className="w-full h-full object-cover"
                      controls={playingVideos[testimonial.id]}
                      playsInline
                      muted={!playingVideos[testimonial.id]}
                      onEnded={() => {
                        setPlayingVideos(prev => ({
                          ...prev,
                          [testimonial.id]: false
                        }));
                      }}
                    />
                    
                    {/* Play Button - only shown when video is not playing */}
                    {!playingVideos[testimonial.id] && (
                      <div 
                        className="absolute inset-0 flex items-center justify-center cursor-pointer z-20"
                        onClick={() => toggleVideo(testimonial.id)}
                      >
                        <div className="w-14 h-14 rounded-full bg-white/30 flex items-center justify-center">
                          <div className="w-12 h-12 rounded-full bg-white flex items-center justify-center">
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M5 3L19 12L5 21V3Z" fill="#012726"/>
                            </svg>
                          </div>
                        </div>
                      </div>
                    )}
                    
                    {/* Author details - only shown when video is not playing */}
                    {!playingVideos[testimonial.id] && (
                      <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/60 to-transparent p-4 z-10">
                        <h3 className="text-white font-bold">{testimonial.videoAuthor}</h3>
                        <p className="text-white text-sm opacity-90">{testimonial.videoRole}</p>
                      </div>
                    )}
                  </div>
                ) : (
                  // Text Card
                  <div className="p-5 flex flex-col h-auto">
                    {/* LinkedIn Icon */}
                    <div className="absolute top-0 right-0">
                      <Image 
                        src="https://d31bwppm8yl9g2.cloudfront.net/learner/website/gslink.svg"
                        alt="LinkedIn"
                        width={34}
                        height={34}
                        className="object-contain"
                      />
                    </div>
                    {/* Testimonial content */}
                    <p className="text-[#012726] text-sm font-normal mb-6 mt-4">{testimonial.content}</p>
                    
                    {/* Author details */}
                    <div className="flex items-center gap-3 mt-auto">
                      <div className="relative w-12 h-12 rounded-sm overflow-hidden">
                        <Image 
                          src={testimonial.image}
                          alt={testimonial.author}
                          fill
                          className="object-cover"
                        />
                      </div>
                      <div>
                        <h3 className="text-[#012726] text-base font-medium">{testimonial.author}</h3>
                        <p className="text-gray-600 text-sm text-normal">{testimonial.role}</p>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        ))}
      </div>

      <div className="flex justify-center mt-8 md:mt-10">
        <Link 
          href="https://home.growthschool.io/wall-of-love"
          target="_blank"
          className="bg-white hover:bg-[#012726] hover:text-white text-[#012726] font-medium px-4 md:px-5 py-3 md:py-4 rounded-xl border w-full md:w-auto transition-colors text-base md:text-lg"
        >
          See Our Wall of Love
        </Link>
      </div>
    </section>
  );
}